/**
 * @generated SignedSource<<26a08e7bdf8aa91cc4608f674106c5c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type collectionHeaderSectionRelayFragment$data = {
  readonly name: string | null | undefined;
  readonly oneLinerHeadline: string | null | undefined;
  readonly " $fragmentType": "collectionHeaderSectionRelayFragment";
};
export type collectionHeaderSectionRelayFragment$key = {
  readonly " $data"?: collectionHeaderSectionRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"collectionHeaderSectionRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "collectionHeaderSectionRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oneLinerHeadline",
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplateCollection",
  "abstractKey": null
};

(node as any).hash = "befafdcd78627f0d1d0a92e99ff48adb";

export default node;
